import { Button, TooltipCommonProps } from '@wix/design-system';
import { ButtonProps } from '@wix/design-system/dist/types/Button/Button.types';
import classnames from 'classnames';
import React, { FC, useCallback, useMemo } from 'react';

import { IButtonItem } from '../../../common/messageCreators';
import { useIsRtlText, useIsSmallScreen } from '../../hooks';
import { DirectionWrapper } from '../DirectionWrapper';
import s from './styles.scss';

type ButtonsDefaultItemProps = {
  item: IButtonItem;
  position: number;
  onClick: (IButtonItem, number) => void;
};

const tooltipProps: TooltipCommonProps = {
  maxWidth: 234,
};

export const ButtonsDefaultItem: FC<ButtonsDefaultItemProps> = ({ item, position, onClick }) => {
  const isSmallScreen = useIsSmallScreen();
  const clickHandler = useCallback(() => {
    onClick(item, position);
  }, [onClick, item, position]);
  const isRtl = useIsRtlText(item.label);
  const linkProps = useMemo(
    (): ButtonProps =>
      item.link
        ? {
            as: 'a',
            href: item.link,
            target: '_blank',
            rel: 'noopener noreferrer',
          }
        : {},
    [item.link],
  );
  const classNames = classnames(s.buttonDirectionWrapper, {
    [s.buttonDirectionWrapperSmallScreen]: isSmallScreen,
  });

  return (
    <DirectionWrapper isRtl={isRtl} className={classNames}>
      <Button
        priority="secondary"
        ellipsis
        onClick={clickHandler}
        dataHook="item"
        data-chatbot-btn-id={item._id}
        tooltipProps={tooltipProps}
        {...linkProps}
      >
        {item.label}
      </Button>
    </DirectionWrapper>
  );
};
